import {objectDifference} from 'helpers';
import {session, rootReducer} from 'store';
import {count, list} from './permissions.selector';

export function permissions({ getState }) {
  return next => action => {
    const currentState = getState();
    const { premium } = session.subscription(currentState);
    const { type, ignorePermissions } = action;

    if (!premium && /^(ACTIVITIES|GOALS|DIARY|NOTES)_/.test(type) && !ignorePermissions) {
      //check if limits were broken
      const currentCount = count(currentState);
      const changes = objectDifference(count(rootReducer(currentState, action)), currentCount);
      const { canAdd } = list(currentState);

      for (const key in changes) {
        if (changes[key] > currentCount[key] && !canAdd[key]) {
          return next({ type: 'SESSION_FORBIDDEN_BY_SUBSCRIPTION' });
        }
      }
    }

    next(action);
  }
}
